import { Dropdown } from "primereact/dropdown";
import React from "react";
import { useTranslation } from "@i18n/hooks";

type LanguageOption = {
	code: string;
	label: string;
	flag: string;
};

const LANGUAGES: LanguageOption[] = [
	{ code: "de", label: "Deutsch", flag: "🇩🇪" },
	{ code: "en", label: "English", flag: "🇬🇧" },
];

export const LanguageSwitcher: React.FC = () => {
	const { i18n } = useTranslation();

	const handleLanguageChange = (e: { value: string }) => {
		i18n.changeLanguage(e.value);
	};

	const selectedLanguage =
		LANGUAGES.find((lang) => lang.code === (i18n.resolvedLanguage ?? i18n.language)) ||
		LANGUAGES[0];

	const languageOptionTemplate = (option: LanguageOption) => {
		return (
			<div className="flex align-items-center gap-2 ml-2">
				<span>{option.flag}</span>
				<span>{option.label}</span>
			</div>
		);
	};

	return (
		<Dropdown
			value={selectedLanguage.code}
			options={LANGUAGES}
			onChange={handleLanguageChange}
			optionLabel="label"
			optionValue="code"
			itemTemplate={languageOptionTemplate}
			valueTemplate={languageOptionTemplate}
			placeholder="Select Language"
		/>
	);
};
